import React from "react";
import {
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import DeleteButton from "../AuthorUIComponents/DeleteButton";
import Select from 'react-select'
import LessonCard from "../LessonCard";
export default class SubcourseData extends React.Component {
  state = {
    displayName: "Apostrophes",
    name: "apostrophesEdit",
    subcourseParent: "Challenger",
    subcourseStatus: true,
 
  };
  showDelete(node) {
    this.setState({ [node.name]: true });
  }
  hideDelete(node) {
    if (!this.state[`${node.name}-clicked`]) {
      this.setState({ [node.name]: false });
    }
  }
  handleClickAway(node) {
    this.setState({
      [`${node.name}-clicked`]: false,
      [node.name]: false
    });
  }
  render() {
    return (
      <React.Fragment>
          <LessonCard
            iconClass="info-lesson"
            heading="Subcourse Data"
            isCollapsable
          >
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Subcourse Name: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input
                  className="grey-field"
                  value={this.state.displayName}
                  onChange={e => {
                    this.setState({
                      displayName: e.target.value,
                      displayNameChanged: true
                    });
                  }}
                  onFocus={e => {
                    //console.log(e.target.value)
                    //this.setState({ displayNameChanged: true })
                  }}
                />
                {this.state.displayNameChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ displayNameChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                <span className="label">Subcourse Code: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <Input
                  value={this.state.name}
                  onChange={e =>
                    this.setState({ name: e.target.value, nameChanged: true })
                  }
                />
                {this.state.nameChanged && (
                  <span
                    className="save-input save-icon"
                    onClick={() => this.setState({ nameChanged: false })}
                  />
                )}
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Subcourse Parent: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <span>{this.state.subcourseParent}</span>
                <span
                  className="modal-link"
                  onClick={() => this.setState({ showModalParent: true })}
                >
                  Change Parent
                </span>
              </Col>
            </Row>

            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Subcourse Status: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                <span>
                  {this.state.subcourseStatus ? "Published" : "Unpublished"}
                </span>
                <span
                  className="modal-link"
                  onClick={() => this.setState({ showModalPublish: true })}
                >
                  {this.state.subcourseStatus ? "Unpublish" : "Publish"}
                </span>
              </Col>
            </Row>
            <Row className="row-lesson">
              <Col colSpan="4" md="4" sm="6">
                {" "}
                <span className="label">Nodes: </span>
              </Col>
              <Col colSpan="8" md="5" sm="6">
                {this.props.nodes.map(node => (
                  <div>
                    <div
                      className="node-name"
                      onMouseEnter={() => this.showDelete(node)}
                      onMouseLeave={() => this.hideDelete(node)}
                    >
                      {node.name}{" "}
                      {
                        <label
                          className={`delete-parent${
                            this.state[`${node.name}`] ? "-active" : ""
                          }`}
                          onClick={() =>
                            this.setState({ [`${node.name}-clicked`]: true })
                          }
                          onBlur={() => this.handleClickAway(node)}
                        >
                          <DeleteButton
                            handleDelete={() => console.log("Delete Node")}
                            index={node.name}
                          />
                        </label>
                      }
                    </div>
                  </div>
                ))}
                <div className="node-btn">
                  <Button
                    className="lesson-action-btn"
                    onClick={() => this.props.toggleCard('editNode')}
                  >
                    Edit Node
                  </Button>
                </div>
              </Col>
            </Row>
          </LessonCard>
     
        
        <Modal isOpen={this.state.showModalParent} className={"modal-custom modal-info"}>
          <ModalHeader>Change Parent</ModalHeader>
          <ModalBody>{"The ${record.name} ${record.collectionName} is currently in this ${record.parentCollectionName}: ${record.parentName}. Move ${record.name} to a different ${record.parentCollectionName}.' List of parents that can be selected. User must select a parent course. Defaults to the current setting. Move button and Cancel button. Move is disabled until a different parent is selected."}{
            <div><span style={{ color: '#375160' , fontSize: '17px' , fontWeight: 'bold' }}>Course:</span><Select /></div>
          }</ModalBody>
          <ModalFooter>
            <Button
              onClick={() => this.setState({ showModalParent: false })}
              className="lesson-action-btn"
            >
              Move
            </Button>
            <Button
              onClick={() => this.setState({ showModalParent: false })}
              color="secondary"
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.showModalPublish} className={"modal-success"}>
          <ModalHeader>Publish Subcourse</ModalHeader>
          <ModalBody>koaskokasdsa</ModalBody>
          <ModalFooter>
            <Button
              onClick={() => this.setState({ showModalPublish: false })}
              color="secondary"
            >
              Publish
            </Button>
            <Button
              onClick={() => this.setState({ showModalPublish: false })}
              color="secondary"
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorSubcourseCards/SubcourseData.js